import { Button, ListItemText, MenuItem, Select } from "@mui/material";
import "../css/CommercialAirlineNavigationBar.css";
import NavigationBar from "./NavigationBar";

const CommercialAirlineNavigationBar = ({
  showHeaderBar = true,
  title,
  navigationLogo,
  showCreateFlightPlanButton,
  onClickCreateFlightPlan,
  backContent,
  airlineData,
  selectedAirline,
  onChangeAirline,
  logoWidth = "auto",
  logoHeight = "auto",
  fullWidthContent = false,
}) => {
  return (
    <div>
      <NavigationBar />
      {showHeaderBar && (
        <header className="commercial-airline-navigation-bar-container">
          <div className="commercial-airline-navigation-bar">
            <div
              className={`commercial-airline-navigation-bar-inner ${fullWidthContent ? "commercial-airline-navigation-bar-full-width" : "align-content"}`}
            >
              <div className="commercial-airline-navigation-bar-left">
                {backContent}
              </div>
              <div className="commercial-airline-navigation-bar-center">
                {navigationLogo && (
                  <img
                    src={navigationLogo}
                    alt="account-maintenance-logo"
                    style={{ width: logoWidth, height: logoHeight }}
                  />
                )}
                <p title={title}>{title}</p>
              </div>
              <div className="commercial-airline-navigation-bar-right">
                {showCreateFlightPlanButton && (
                  <Button
                    variant="contained"
                    className="create-flight-plan "
                    onClick={onClickCreateFlightPlan}
                  >
                    Create a Flight Plan
                  </Button>
                )}
                {airlineData && (
                  <Select
                    id="create-flight-plan-airline"
                    className="commercial-airline-navigation-bar-select-container"
                    value={selectedAirline?.id || ""}
                    onChange={onChangeAirline}
                    displayEmpty
                    renderValue={(selected) =>
                      selected ? (
                        airlineData?.data?.find(
                          (airline) => airline?.id === selected
                        )?.airlineName
                      ) : (
                        <span className="placeholder-text">Select</span>
                      )
                    }
                  >
                    {airlineData?.data?.map((airline) => (
                      <MenuItem key={airline?.id} value={airline?.id}>
                        <ListItemText primary={airline?.airlineName} />
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </div>
            </div>
          </div>
        </header>
      )}
    </div>
  );
};

export default CommercialAirlineNavigationBar;